import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.BOOST_FLUENCY;

export const READING_ATTEMPTS = 2; // readings per assignment

// Pause after a VO before the next VO or audio starts.
export const VO_GAP_MS = 500;

export const SCREENS = {
  LOADING: 'LOADING',
  MIC_ACCESS: 'MIC_ACCESS',
  MIC_CHECK: 'MIC_CHECK',
  CHALLENGE_WORDS: 'CHALLENGE_WORDS',
  PASSAGE_TITLE: 'PASSAGE_TITLE',
  RESUME: 'RESUME',
  PASSAGE_RECORDING: 'PASSAGE_RECORDING',
  STUDENT_FEEDBACK: 'STUDENT_FEEDBACK',
  MODEL_EXAMPLE: 'MODEL_EXAMPLE',
  COMPREHENSION_QUESTION: 'COMPREHENSION_QUESTION',
};

export const FLUENCY_VISITED_SESSION_KEY = 'fluencyVisited';
export const FLUENCY_COMPLETED_SESSION_KEY = 'fluencyCompleted';

export const REDUX_ACTIONS = {
  SET_PASSAGE_CONTENT: 'SET_PASSAGE_CONTENT',
  CLEAR_FLUENCY_ASSIGNMENT: 'CLEAR_FLUENCY_ASSIGNMENT',
  SET_FLUENCY_ASSIGNMENT: 'SET_FLUENCY_ASSIGNMENT',
  SET_FLUENCY_VISITED: 'SET_FLUENCY_VISITED',
  SET_FLUENCY_SUPPRESSION_ARMED: 'SET_FLUENCY_SUPPRESSION_ARMED',
};

// Semantic color tokens for Boost Fluency.
// Only colors that repeat across files are tokenized here; component-local
// accent colors (e.g. karaoke highlight, ASR feedback) stay in their components.
export const COLORS = {
  teal: {
    primary: '#019F8E',
    dark: '#00766A',
    border: '#68C6BC',
    text: '#008575',
  },
  box: {
    bg: '#F6F6F6',
  },
  blue: '#306DD2',
};

// Font stacks used across Boost Fluency. Keys are semantic roles, not font names.
export const FONTS = {
  heading: "'Quicksand Bold', sans-serif",
  label: "'Quicksand Medium', sans-serif",
  pageNumber: "'Quicksand SemiBold', 'Quicksand Medium', sans-serif",
  emphasis: "'Benton Sans Medium', sans-serif",
  body: "'Benton Sans', sans-serif",
  passage: "'Benton Sans Regular', sans-serif",
};
